import React from 'react';
import PropTypes from 'prop-types';

import FieldInputNumber from './FieldInputNumber';

/**
 * FieldInputPercent
 * @param {*} param0
 */
const FieldInputPercent = ({
  code,
  disabled,
  decimalScale,
  thousandSeparator,
  decimalSeparator,
  minValue,
  maxValue,
  validate,
  existError,
  showError,
  handleBlur,
}) => {
  const isAllowed = values => {
    const { floatValue } = values;
    return !floatValue || (floatValue <= maxValue && floatValue >= minValue);
  };

  return (
    <FieldInputNumber
      code={code}
      disabled={disabled}
      decimalScale={decimalScale}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      suffix="%"
      isAllowed={isAllowed}
      validate={validate}
      existError={existError}
      showError={showError}
      handleBlur={handleBlur}
    />
  );
};

FieldInputPercent.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  validate: PropTypes.func.isRequired,
  decimalScale: PropTypes.number,
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  handleBlur: PropTypes.func.isRequired,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
};

FieldInputPercent.defaultProps = {
  decimalScale: 2,
  thousandSeparator: undefined,
  decimalSeparator: undefined,
  disabled: false,
  minValue: 0,
  maxValue: 100,
};

export default FieldInputPercent;
